import { InfoOutlined } from "@mui/icons-material";
import React from "react";

const CustomerAlert = () => {
  return (
    <div className="flex flex-wrap gap-2 items-center justify-between bg-yellow-50 text-yellow-600 border !border-yellow-200 rounded-tl-[12px] rounded-tr-[12px] p-[5px]">
      <div className="flex gap-2 items-center">
        <InfoOutlined className="text-yellow-600" />
        <span className="text-[13px] md:text-[16px]">
          This customer has an unpaid Account Balance.
        </span>
      </div>
      {/* <Button
        className="w-full md:w-auto"
        onClick={handleAddPayment}
        size="small"
        variant="text"
      >
        Add Payment
      </Button> */}
    </div>
  );
};

export default CustomerAlert;
